import lot from '@/api/modules/lot';

export default {
	async getTypes({commit}) {
		try {
			const typesArr = await lot.getTypes();
			commit('setTypes', typesArr);
		} catch (e) {
			//
		}
	},

	async getVehicleTypes({commit}) {
		try {
			const vehicleTypesArr = await lot.getVehicles();
			commit('setVehicleTypes', vehicleTypesArr);
		} catch (e) {
			//
		}
	},

	async getCompanies({commit}) {
		try {
			let data = await lot.getCompanies();
			let providersArr = [];
			let brokersArr = [];
			data.forEach(el => {
				if (el.type.toLowerCase() === 'provider') {
					providersArr.push(el);
				}
			});
			data.map(el => {
				if (el.type.toLowerCase() === 'recipient') {
					brokersArr.push(el);
				}
			});
			commit('setProviders', providersArr);
			commit('setBrokers', brokersArr);
		} catch (e) {
			//
		}
	},

	async getWarehouses({commit}) {
		try {
			let warehousesArr = await lot.getWarehouses();

			// Костыль для отделения складов с contractor_id
			if (warehousesArr.length) {
				const contractorsArr = await lot.getCompanies();

				warehousesArr = warehousesArr.filter(warehouse => {
					const finded = contractorsArr.find(contractor => contractor.id === warehouse.contractor_id && contractor.type === 'PROVIDER');
					return finded ? false : true;
				});
			}
			// конец

			commit('setWarehousesArr', warehousesArr);
		} catch (e) {
			//
		}
	},

	async getCrossings({commit}) {
		try {
			const crossings = await lot.getCrossings();
			commit('setCrossings', crossings);
		} catch (e) {
			//
		}
	},

	async getClearances({commit}) {
		try {
			const clearances = await lot.getClearances();
			commit('setClearances', clearances);
		} catch (e) {
			//
		}
	},

	async getCargoTypes({commit}) {
		try {
			const cargoTypes = await lot.getCargoTypes();
			commit('setCargoTypes', cargoTypes);
		} catch (e) {
			//
		}
	},

	async getCurrencies({commit}) {
		try {
			const currencies = await lot.getCurrencies();
			commit('setCurrencies', currencies);
		} catch (e) {
			//
		}
	}
};
